import React, { useState, useEffect } from "react";
import "./SeatSelector.css";

const SeatSelector = ({ seats = [], maxSeats = 1, onSelect }) => {
  const [selectedSeats, setSelectedSeats] = useState([]);

  useEffect(() => {
    // reset selection when maxSeats or seats change
    setSelectedSeats([]);
  }, [maxSeats, seats]);

  const handleSeatClick = (seat) => {
    // block driver’s seat or unavailable
    if (seat.seatNumber === "A1" || !seat.available) return;

    const alreadySelected = selectedSeats.find((s) => s.seatId === seat.seatId);

    if (alreadySelected) {
      const updated = selectedSeats.filter((s) => s.seatId !== seat.seatId);
      setSelectedSeats(updated);
      onSelect(updated);
    } else {
      if (selectedSeats.length < maxSeats) {
        const updated = [...selectedSeats, seat];
        setSelectedSeats(updated);
        onSelect(updated);
      } else {
        alert(`You can only select ${maxSeats} seat(s)`);
      }
    }
  };

  // group seats by row
  const rows = seats.reduce((acc, seat) => {
    acc[seat.seatRow] = acc[seat.seatRow] || [];
    acc[seat.seatRow].push(seat);
    return acc;
  }, {});

  // check if all seats except driver are reserved
  const allReserved =
    seats.filter((seat) => seat.seatNumber !== "A1").every((seat) => !seat.available);

  return (
    <div className="seat-selector">
      {/* Legend */}
     <div className="seat-legend">
        <div className="legend-item">
          <div className="legend-box driver"></div>
          Driver
        </div>
        <div className="legend-item">
          <div className="legend-box occupied"></div>
          Booked
        </div>
        <div className="legend-item">
          <div className="legend-box available"></div>
          Available
        </div>
      </div>

      {/* Seat grid */}
      {Object.keys(rows).map((row) => (
        <div key={row} className="seat-row">
          {rows[row].map((seat) => {
            const isSelected = selectedSeats.find((s) => s.seatId === seat.seatId);
            const isDriver = seat.seatNumber === "A1";
            return (
              <div
                key={seat.seatId}
                className={`seat 
                  ${isDriver ? "driver" : ""} 
                  ${!seat.available ? "occupied" : ""} 
                  ${isSelected ? "selected" : ""}`}
                onClick={() => handleSeatClick(seat)}
              >
                {seat.seatNumber}
              </div>
            );
          })}
        </div>
      ))}

      {/* Message if all reserved */}
      {allReserved && (
        <p className="all-reserved-message">
          All seats have been reserved. Please check back in 15 minutes for availability.
        </p>
      )}
    </div>
  );
};

export default SeatSelector;
